export default __webpack_public_path__ + "static/media/icon-econsult.119a040b.svg";